module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap firmorder-wrap flex-column"
  }, [_c('mu-infinite-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay.loading),
      expression: "pay.loading"
    }],
    staticClass: "load maskloading",
    attrs: {
      "loading": _vm.pay.loading,
      "loadingText": _vm.pay.message
    }
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    staticClass: "flex-item firmorderWrapper"
  }, [_c('div', {
    staticClass: "firmorder-content"
  }, [(_vm.addressInfo.length > 0) ? _c('div', {
    staticClass: "order-box addr"
  }, [_c('div', {
    staticClass: "border-img top"
  }), _vm._v(" "), _c('div', {
    staticClass: "addr-info",
    on: {
      "click": _vm.openaddr
    }
  }, [_c('p', {
    staticClass: "addr-title"
  }, [_vm._v("收货人信息")]), _vm._v(" "), _c('p', [_vm._v("\n            收货人：" + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].consignee) + "\n            "), _c('label', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].mobile))])]), _vm._v(" "), _c('p', [_vm._v("\n            收货地址：" + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].province) + "\n            " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].city) + "\n            " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].area) + "\n            " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].address) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "border-img bottom"
  })]) : _c('div', {
    staticClass: "order-box addr"
  }, [_c('div', {
    staticClass: "border-img top"
  }), _vm._v(" "), _c('div', {
    staticClass: "none-addr-info"
  }, [_c('p', [_vm._v("您还没有收货地址，赶快添加吧！")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "+ 新建地址"
    },
    on: {
      "click": _vm.addaddr
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border-img bottom"
  })]), _vm._v(" "), _vm._l((_vm.OrderSettleMsg.storeOrderSettleMsgs), function(storeItem, storeIndex) {
    return [_c('div', {
      staticClass: "order-box"
    }, [_c('div', {
      staticClass: "brandTitle"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.gotoBrandHome(storeItem.settleGoodsMsg.storeId)
        }
      }
    }, [_c('imgs', {
      staticClass: "logo floatL",
      attrs: {
        "width": 120,
        "imagePath": storeItem &&
          storeItem.settleGoodsMsg &&
          storeItem.settleGoodsMsg.storeLogoPath &&
          storeItem.settleGoodsMsg.storeLogoPath.imagePath
      }
    }), _vm._v(" "), _c('p', [_c('label', [_vm._v("品牌：" + _vm._s(storeItem.settleGoodsMsg.storeName))])]), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 1), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.settleDatas[storeIndex].dealerCode),
        expression: "settleDatas[storeIndex].dealerCode"
      }],
      attrs: {
        "placeholder": "经销商编码"
      },
      domProps: {
        "value": (_vm.settleDatas[storeIndex].dealerCode)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.settleDatas[storeIndex], "dealerCode", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('mu-list', _vm._l((storeItem.settleGoodsMsg
      .cartGoodses), function(goodItem, goodIndex) {
      return _c('myOrdersItem', {
        key: goodIndex,
        attrs: {
          "cartitem": goodItem
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "order-box"
    }, [(storeItem.couponMsgs.length > 0) ? _c('p', {
      staticClass: "order-box-item",
      on: {
        "click": function($event) {
          _vm.couponPopup = true;
          _vm.currentCoupon = storeIndex;
        }
      }
    }, [_vm._v("\n            优惠券：\n            "), _c('label', {
      staticClass: "fr black"
    }, [(_vm.settleDatas[storeIndex].couponInstId == 0) ? [_vm._v("不使用优惠券")] : _vm._e(), _vm._v(" "), (
      _vm.settleDatas[storeIndex].couponInstId != 0 &&
      _vm.couponAmounts[storeIndex].couponCate == 3
    ) ? [_vm._v(_vm._s(_vm._f("discount")(_vm.couponAmounts[storeIndex].couponDiscount)) + "折优惠券")] : _vm._e(), _vm._v(" "), (
      _vm.settleDatas[storeIndex].couponInstId != 0 &&
      _vm.couponAmounts[storeIndex].couponCate != 3
    ) ? [_vm._v(_vm._s(_vm.couponAmounts[storeIndex]) + "元优惠券")] : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 2)]) : _c('p', {
      staticClass: "order-box-item"
    }, [_vm._v("\n            优惠券：\n            "), _c('label', {
      staticClass: "fr not-available"
    }, [_vm._v("无可用")])]), _vm._v(" "), (storeItem.redpacketMsgs.length > 0) ? _c('p', {
      staticClass: "order-box-item",
      on: {
        "click": function($event) {
          _vm.redpackagePopup = true;
          _vm.currentCoupon = storeIndex;
        }
      }
    }, [_vm._v("\n            红包：\n            "), _c('label', {
      staticClass: "fr black"
    }, [(_vm.settleDatas[storeIndex].redpacketInstId == 0) ? [_vm._v("不使用红包")] : _vm._e(), _vm._v(" "), (_vm.settleDatas[storeIndex].redpacketInstId != 0) ? [_vm._v(_vm._s(_vm.redpacketAmounts[storeIndex]) + "元红包")] : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 2)]) : _c('p', {
      staticClass: "order-box-item"
    }, [_vm._v("\n            红包："), _c('label', {
      staticClass: "fr not-available"
    }, [_vm._v("无可用")])])]), _vm._v(" "), _c('div', {
      staticClass: "order-box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.settleDatas[storeIndex].remark),
        expression: "settleDatas[storeIndex].remark"
      }],
      staticClass: "order-box-item",
      attrs: {
        "placeholder": "选填：给商家留言 （50字以内）"
      },
      domProps: {
        "value": (_vm.settleDatas[storeIndex].remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.settleDatas[storeIndex], "remark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "order-box mgb"
    }, [_c('p', {
      staticClass: "order-box-item"
    }, [_vm._v("\n             \n            "), _c('label', {
      staticClass: "fr"
    }, [_vm._v("合计："), _c('span', {
      staticClass: "primary"
    }, [_vm._v("￥" + _vm._s(storeItem.finalPrice))])])])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "order-box mgb"
  }, [_c('p', {
    staticClass: "order-box-item",
    on: {
      "click": _vm.openinvoice
    }
  }, [_vm._v("\n          发票信息：\n          "), _c('label', {
    staticClass: "fr black"
  }, [_vm._v(_vm._s(_vm.invoinceInfo)), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "order-box mgb"
  }, [_c('p', {
    staticClass: "order-box-item"
  }, [_vm._v("\n          商品金额：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("￥" + _vm._s(_vm.OrderSettleMsg.totalGoodsPrice))])]), _vm._v(" "), _c('p', {
    staticClass: "order-box-item"
  }, [_vm._v("\n          运费：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("+￥" + _vm._s(_vm.OrderSettleMsg.postPrice))])]), _vm._v(" "), _c('p', {
    staticClass: "order-box-item"
  }, [_vm._v("\n          优惠券：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("-￥" + _vm._s(_vm.OrderSettleMsg.discountPrice))])]), _vm._v(" "), _c('p', {
    staticClass: "order-box-item textright"
  }, [_vm._v("\n          实付款：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("￥" + _vm._s(_vm.OrderSettleMsg.finalPrice))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "fullbtn-box"
  }, [_c('mu-raised-button', {
    staticClass: "full",
    attrs: {
      "label": "创建订单",
      "fullWidth": ""
    },
    on: {
      "click": _vm.onCreatOrder
    }
  })], 1)]), _vm._v(" "), (_vm.scrolled > 200 && _vm.addressInfo.length > 0 && !_vm.load) ? _c('p', {
    staticClass: "delivery-addr"
  }, [_vm._v("\n    配送至：" + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].province) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].city) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].area) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].address) + "\n    （\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].consignee) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].mobile) + "\n    收）\n  ")]) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-popup-bottom flex-column",
      "open": _vm.couponPopup
    },
    on: {
      "close": function($event) {
        _vm.couponPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  }), _vm._v(" "), (_vm.currentCoupon >= 0) ? _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n              选择优惠券\n            ")]), _vm._v(" "), _vm._l((_vm.OrderSettleMsg
    .storeOrderSettleMsgs[_vm.currentCoupon].couponMsgs), function(couponItem, couponIndex) {
    return _c('div', {
      staticClass: "coupon-list-item",
      on: {
        "click": function($event) {
          return _vm.selCoupon('1', couponItem.couponInstId)
        }
      }
    }, [(couponItem.couponInstId == 0) ? [_vm._v("\n                " + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), (couponItem.couponInstId != 0) ? [(couponItem.couponCate != 3) ? [_vm._v("省" + _vm._s(couponItem.couponAmount) + "元")] : _vm._e(), _vm._v(" "), (couponItem.couponCate == 3) ? [_vm._v(_vm._s(_vm._f("discount")(couponItem.couponDiscount))), _c('samp', [_vm._v("折")])] : _vm._e(), _vm._v("\n                ：满" + _vm._s(couponItem.useableAmount) + "可用，" + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), _c('mu-radio', {
      staticClass: "list-radio fr",
      attrs: {
        "name": "group",
        "nativeValue": '' + couponItem.couponInstId
      },
      on: {
        "change": function($event) {
          return _vm.selCoupon('1', couponItem.couponInstId)
        }
      },
      model: {
        value: (_vm.settleDatas[_vm.currentCoupon].couponInstId),
        callback: function($$v) {
          _vm.$set(_vm.settleDatas[_vm.currentCoupon], "couponInstId", $$v)
        },
        expression: "settleDatas[currentCoupon].couponInstId"
      }
    })], 2)
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-popup-bottom flex-column",
      "open": _vm.redpackagePopup
    },
    on: {
      "close": function($event) {
        _vm.redpackagePopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.redpackagePopup = false
      }
    }
  }), _vm._v(" "), (_vm.currentCoupon >= 0) ? _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n              选择红包\n            ")]), _vm._v(" "), _vm._l((_vm.OrderSettleMsg
    .storeOrderSettleMsgs[_vm.currentCoupon].redpacketMsgs), function(couponItem, couponIndex) {
    return _c('div', {
      staticClass: "coupon-list-item",
      on: {
        "click": function($event) {
          return _vm.selCoupon('2', couponItem.couponInstId)
        }
      }
    }, [(couponItem.couponInstId == 0) ? [_vm._v("\n                " + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), (couponItem.couponInstId != 0) ? [_vm._v("\n                省" + _vm._s(couponItem.couponAmount) + "元：满" + _vm._s(couponItem.useableAmount) + "可用，" + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), _c('mu-radio', {
      staticClass: "list-radio fr",
      attrs: {
        "name": "group",
        "nativeValue": '' + couponItem.couponInstId
      },
      on: {
        "change": function($event) {
          return _vm.selCoupon('2', couponItem.couponInstId)
        }
      },
      model: {
        value: (_vm.settleDatas[_vm.currentCoupon].redpacketInstId),
        callback: function($$v) {
          _vm.$set(_vm.settleDatas[_vm.currentCoupon], "redpacketInstId", $$v)
        },
        expression: "settleDatas[currentCoupon].redpacketInstId"
      }
    })], 2)
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isShowFirmBox,
      "title": "请确认微信支付是否已完成",
      "titleClass": "payTitle dialogTitle",
      "bodyClass": "dialogBody payBody",
      "actionsContainerClass": "payActionsContainer"
    }
  }, [_c('div', {
    on: {
      "click": _vm.finishPay
    }
  }, [_vm._v("已完成支付")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    on: {
      "click": function($event) {
        return _vm.callH5WxPay(_vm.createOrderData.orderId)
      }
    },
    slot: "actions"
  }, [_vm._v("\n      支付遇到问题，重新支付\n    ")])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3468353a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/firmorder.vue
// module id = 390
// module chunks = 68